<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{titulo}}</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        v-if="puedoEditar()"
        @click="editar()"
        class="ma-0"
      >
        <v-icon
          small
          color="blue-grey"
        >edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <v-container
      grid-list-md
      v-else
    >
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-model="itemSeleccionado.nombre"
            v-validate="'required|max:50'"
            :counter="50"
            :error-messages="errors.collect('nombre')"
            label="Nombre"
            data-vv-name="nombre"
            required
            :disabled="soloLectura"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          v-if="itemSeleccionado.id === 0"
        >
          <v-text-field
            v-model="itemSeleccionado.codigo"
            v-validate="'required|max:50'"
            :counter="50"
            :error-messages="errors.collect('codigo')"
            label="Codigo"
            data-vv-name="codigo"
            required
            :disabled="soloLectura"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="itemSeleccionado.padre_id"
            :items="info.tipoEntidades"
            item-text="nombre"
            item-value="id"
            label="Padre"
            :disabled="soloLectura"
          ></v-select>
        </v-flex>

      </v-layout>

    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedo(operacion) && !soloLectura"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import _ from 'lodash'

export default {
  name: 'TipoEntidadesAbmFormulario',
  mixins: [abmFormularioMixin],
  methods: {
    cargarInfo () {
      let vm = this

      let dataCombos = {
        tipoEntidades: {
          itemVacio: true
        }
      }

      Combo.listado(dataCombos).then(data => {
        vm.info = _.assign(vm.info, data)
        this.cargando = false
      }, error => {
        this.mostrarError(error)
        this.soloLectura = true
        this.cargando = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
